var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgCheckIn = function SvgCheckIn(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10489 5.6514C5.5605 5.19579 6.2992 5.19579 6.75481 5.6514L16.4298 15.3264V6.47636C16.4298 5.83203 16.9522 5.30969 17.5965 5.30969C18.2408 5.30969 18.7632 5.83203 18.7632 6.47636V18.143C18.7632 18.7874 18.2408 19.3097 17.5965 19.3097H5.92985C5.28552 19.3097 4.76318 18.7874 4.76318 18.143C4.76318 17.4987 5.28552 16.9764 5.92985 16.9764H14.7799L5.10489 7.30132C4.64928 6.84571 4.64928 6.10701 5.10489 5.6514Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgCheckIn);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/CheckIn.9a05fa6cf1bf86aa06649106fe4a758d.svg";